import { render, staticRenderFns } from "./SpaceConfigurations.vue?vue&type=template&id=5d3aa6cd&scoped=true"
import script from "./SpaceConfigurations.vue?vue&type=script&lang=ts"
export * from "./SpaceConfigurations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3aa6cd",
  null
  
)

export default component.exports